export default {
  getExternalPartnerStatuses: state => state.externalPartnerStatuses,

  getPartners: state => state.partners,
  getPartnersTotal: state => state.partnersTotal,
  getPartnersLimit: state => state.partnersLimit,
  getPartnersPage: state => state.partnersPage,

  getPartner: state => state.partner,

  getAssignedUsers: state => state.assignedUsers,
  getAssignedUsersTotal: state => state.assignedUsersTotal,

  getAssignableUsers: state => state.assignableUsers,
  getAssignableUsersTotal: state => state.assignableUsersTotal,

  getCustomerMappings: state => state.customerMappings,
  getCustomerMappingsTotal: state => state.customerMappingsTotal,

  getCustomersLookup: state => state.customersLookup,
  getCustomersLookupTotal: state => state.customersLookupTotal,
}
